module.exports = __webpack_public_path__ + "static/media/delete.f69b9028.svg";